import { Env } from "@ancademy/vse-client";
import { SubGameType, SubNamespace } from "@share";

export const ABU = `${Env.basePath}/static/asset/`;

export const CityName = {
  from: "蓉城",
  to: "江城",
};

export const GameTypeConfigList: {
  type: SubGameType;
  label: string;
  desc: string;
  videoUrl: string;
  subNamespaceList: SubNamespace[];
}[] = [
  {
    type: SubGameType.simpleSearchConcept,
    label: "简单的搜寻",
    desc: `搜寻——一个常见的生活现象
搜寻是大多数人都需要做出的决策。当你来到一个陌生的城市，开展新的生活，你需要搜寻合适的住房，需要寻找适合的工作，需要在消费品市场中选择最喜欢的产品，希望遇见志趣相同的朋友…
即使你已经熟悉了周边的环境，有了稳定的生活，你仍然不会放弃搜寻其它的机会。即使是看似普通的每一天，你也有可能面对这各式各样的搜寻问题：中饭是不是换个地方吃？要不要尝一尝店里的新菜？下午是否要参加某个新的社团活动，听一个讲座？晚上要不要去图书馆借一本新书？还是找一条没走过的绿道散散步？
消费者市场搜寻看似一个特殊的研究话题，但从某种意义上来说，搜寻是我们生活中每时每刻都可能做出的决定。它的本质是一个从已知走向未知，并且进一步认识未知的决策过程。
人们之所以做出搜寻的决定，并探索未知的选项，一定是基于一种美好的期望：即未知的选项有可能带来更高的收益—无论这种收益是经济上的，还是精神体验上的。在每一次搜寻水落石出之后，决策者将获得新的收获，无论好坏；接下来他（她）将决定是否进行再一次的搜寻。
如何使用简单的方法，并在简洁的环境来理解（市场）搜寻这一决策过程呢？为了更好的理解搜寻决策，我们需要温习一些学习过的知识；需要深刻的理解以下几个概念。这些概念包括“期望”，“ 风险”， “期望效用”，“搜寻成本”等。`,
    videoUrl: ``,
    subNamespaceList: [SubNamespace.Concept],
  },
  {
    type: SubGameType.simpleSearch,
    label: "简单的搜寻市场",
    desc: `将搜寻问题放在市场中考虑
上一节，我们对搜寻问题本身初窥门径，我们掌握了简化的搜寻问题的数学表达。然而市场中的消费者搜寻问题通常更为复杂。部分原因是不同的搜寻市场有很多差异化的特征，这些特征影响着消费者的搜寻行为。比如，有的市场搜寻成本极其高昂，而另一些市场则可以更容易的收集到产品信息。再比如，不同的市场限定了不同的搜寻规则：有些时候，消费者可以从多个备选项进行选择，有些时候，消费者不得不一次只搜寻一个备选项；有的时候消费者选择搜寻的顺序会受到卖家的影响…
为了研究并且理解这些现象，我们需要从这些市场中抽象出共性的元素，简化、模拟消费者搜寻市场中的共性元素，使得我们能更好的认识消费者市场搜寻的关键问题。请假想你来到一个陌生的城市，作为开展新生活的第一步，你需要完成一系列的搜寻的任务。
与简单搜寻相比，在一个一般化的市场中，消费者搜寻的最大区别是他们会面临多个搜寻选项。因此我们首先考虑搜寻顺序的假设。在学者对消费者搜寻市场的研究中，最简单常用的假设是消费者在市场搜寻时的顺序是随机的。
当消费者不清楚产品的特征时，随机的市场搜寻是可信的。比如在陌生的城市中，消费者搜寻并租用合适的房源。因为二手房的很多特征是难以被标准化的，消费者无法在搜寻前获得关于房屋内部细节、邻里环境等重要信息。因此，消费者可能在符合要求（比如基本预算、位置、设备等）的房源中“随机”选取房源进行搜寻、询价，并且决定是否要继续搜寻。
`,
    videoUrl: `${ABU}video/mg01.mp4`,
    subNamespaceList: [SubNamespace.RentHouse, SubNamespace.FindJob],
  },
  {
    type: SubGameType.advancedSearch,
    label: "进阶的搜寻市场",
    desc: `更常见的搜寻问题
本节的一个重要主题，是赋予消费者搜寻成本以更丰富的含义。在上一节的第一部分搜寻模型中，搜寻成本是一个外部给定的、确定的“参数”；返回的成本则为0。消费者在这样的环境中可以较轻松的判断他（她）预期的收益是否高于这一给定的成本--该成本在整个市场搜寻中保持不变。而第二部分搜寻模型中，消费者无法返回之前的卖家，可以理解为，消费者返回的“成本”接近无穷大。在更常见的搜寻市场中，卖方可以通过不同的销售策略来影响搜寻或者返回的成本。而这些销售策略的核心通常落在价格条款上。消费者搜寻产品后，了解了某一产品可能给其带来的收益v，同时，消费者也需要按照卖家的价格条款来购买费用。不同卖家设置不同的价格条款使得消费者落入更复杂的搜寻情境当中。
在本节，我们考虑卖家可能影响消费者的数种模式：
首先，卖家可以提供给买家极短时间内有效的价格优惠。如果消费者不能立刻做出购买决策，则无法享受该价格优惠。消费者在进行搜寻后将被迫接受更高的价格，因此变相的增加了其搜寻成本。
其次，卖家可以要求买家在到店后预付一部分定金，以“锁定”商品的购买权。如果消费者最终决定不购买该卖家的商品，则会损失这一笔定金（或者这笔定金极难索回）。因此卖家的预付定金策略也增加了消费者搜寻市场的成本。
最后，卖家可以通过提供复杂的价格条款或者产品信息增加消费者搜寻时的计算量，使得每次搜寻的时间和难度增加。消费者在时间压力和较大的计算量下可能减少实质的搜寻。
接下来，我们就以具体的市场为例，逐一分析这些搜寻市场/情境的特点。`,
    videoUrl: `${ABU}video/mg02.mp4`,
    subNamespaceList: [SubNamespace.BuyCar, SubNamespace.BuyTicket, SubNamespace.BuyInsurance, SubNamespace.BuyHouse],
  },
  {
    type: SubGameType.sale,
    label: "影响搜寻的促销策略--卖家视角",
    desc: `搜寻问题的另一面：卖家
消费者搜寻问题的另一面是卖家的销售策略。只有理解了卖家的思维逻辑，我们才能更好的解释为什么市场上会存在类似的销售策略。在这一章节，我们将重点考虑卖方和消费者之间的策略互动。
为了分析这种策略互动，我们使用博弈论中的均衡分析方法：我们把买卖双方的互动抽象成一个“贯序博弈”。卖方销售某一产品或者服务，它首先进行决策，确定产品的价格和促销策略；接着，买方访问卖家，并决定是否购买卖方提供的产品。买方如果不愿意接受卖家的促销方案，可以选择继续搜寻市场中的其它选项。我们把其它选项抽象成一个“外部机会”。也就是说，买方可能通过搜寻获得一个购买更好产品的机会，从而获得更高的收益，也有可能无法找到更好的选项，因此有可能遭受损失。
卖家在这样的市场中的目标是最大化其净收益或者利润。我们姑且不讨论生产产品所需要的成本，仅从销售的视角触发。换句话说，卖家希望以较高的价格卖出足够多的产品--在销量和价格之间达到某种最优的平衡。为此，卖家需要去理解买家的需求如何随着其销售策略的影响。可以猜测：买家的市场搜寻将减少对卖家的需求量，卖家有动机通过促销手段减弱搜寻行为。
虽然在我们的虚拟市场中，买方的市场搜寻决策被大大的简化了，但是这种简化并没有失去买家市场搜寻的一般特征。买家同样面临了搜寻和不搜寻的权衡。同时，这种简化有助于我们聚焦卖家的决策逻辑和最优决策。`,
    videoUrl: `${ABU}video/mg04.mp4`,
    subNamespaceList: [SubNamespace.SaleFurniture, SubNamespace.SaleCar],
  },
  {
    type: SubGameType.trade,
    label: "促销策略--卖家间的竞争",
    desc: `搜寻市场中的卖家竞争
在之前的学习之中，我们并没有引入卖家之间的竞争，而是更多的聚焦在消费者自身的最优化问题，以及消费者与垄断卖家之间的博弈互动上。
在垄断市场的买卖博弈中，我们具体分析了垄断卖家的决策逻辑：卖家先考虑买家的最优搜寻行为，以及其产生的需求；接着，给定这一最优行动，卖家选择合适的促销策略最大化其利润。因为买家和卖家都基于对方的（最优）行动进行回应，因此，博弈的策略是一种均衡。完美理性的决策者不会单方面偏离这样的均衡。
当市场中出现了多名卖家，卖家在从买家处获得利润的同时，不得不兼顾其它卖家的促销策略对市场以及对买家行为的影响。我们仍然从较为理想的环境出发，考虑消费者随机的搜寻市场中的卖家，同时市场中存在完全对称的两个卖家。消费者首先搜寻任意一个卖家，并且决定是否直接购买，还是继续搜寻。其它市场环境与之前的例子相似。
可以想象，在给定需求下，卖家需要考虑根据对手在不同的策略下，自己的最优反应。此时，卖家应该如何选择促销策略呢？卖家是否愿意通过限时优惠、预售定金、拒绝返回等销售策略增加消费者的搜寻成本呢？我们将通过以下两个实验来了解卖家的最优决策所具有的性质。`,
    videoUrl: `${ABU}video/mg05.mp4`,
    subNamespaceList: [SubNamespace.TradeCar, SubNamespace.Bargain],
  },
];

export function getSubGameType(namespace: SubNamespace) {
  return GameTypeConfigList.find((s) => s.subNamespaceList.includes(namespace));
}
